import error_icon from 'assets/images/error_404.png'
import house_icon from 'assets/images/house_icon.svg'
import cn from 'classnames'
import { Image } from 'components/Custom'
import { Box, Container, Typography } from 'components/Material/index'
import { useMediaQuery } from 'react-responsive'
import useTextStyles from 'styles/useTextStyles'
import large_seguro from 'assets/images/large_seguro.png'

// Refatoração: Mudar para o padrão de design: Design Composition

type RightIconImage = {
  vamos_comecar: string
  error_not_found: string
  seguros: string
}

const right_icon_image: RightIconImage = {
  vamos_comecar: house_icon,
  error_not_found: error_icon,
  seguros: large_seguro
}

type Props = {
  title: string
  title2?: string
  subtitle?: string
  subtitle2?: string
  rightImage?: keyof RightIconImage | false
  isSidebarOpen?: boolean
  className?: string
  center?: boolean
  defaultPadding?: boolean
  centerSmallWidth?: boolean
  smallTitle?: boolean
  titleLeft?: boolean
}
export const HouseHeader = ({
  title,
  title2 = '',
  subtitle,
  subtitle2 = '',
  rightImage,
  defaultPadding,
  className,
  center = false,
  centerSmallWidth,
  smallTitle = false,
  titleLeft = false
}: Props) => {
  const isMobile = useMediaQuery({ query: '(max-width: 1023px)' })

  const titleSx = smallTitle
    ? {
        ...useTextStyles.headlineLarge,
        fontSize: '2.5rem',
        lineHeight: '3rem',
        '@media (min-width: 640px)': {
          fontSize: '3rem',
          lineHeight: '3.5rem'
        }
      }
    : {
        ...useTextStyles.headlineLarge,
        fontSize: '2.75rem',
        lineHeight: '3rem',
        '@media (min-width: 640px)': {
          ...useTextStyles.displayLarge
        }
      }

  const headLineText = (subtitle2 || subtitle) && (
    <Box
      className={cn(
        'flex flex-col w-full',
        { 'mt-2': !titleLeft },
        { 'max-w-[350px] md:max-w-[550px]': rightImage },
        { 'max-w-[350px] md:max-w-full': !rightImage }
      )}
    >
      {subtitle && (
        <Typography
          sx={{
            ...(isMobile ? { ...useTextStyles.titleSmall } : { ...useTextStyles.headlineSmall })
          }}
          className="w-full"
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      )}
      {subtitle2 && (
        <Typography
          sx={{
            ...(isMobile ? { ...useTextStyles.titleSmall } : { ...useTextStyles.bodyMedium })
          }}
          className="w-full"
          dangerouslySetInnerHTML={{ __html: subtitle2 }}
        />
      )}
    </Box>
  )

  const titleText = (
    <Box className={cn('max-w-[350px] lg:max-w-[550px]', { 'lg:w-full': rightImage })}>
      <Typography variant="h2" className="text-blue-bb" sx={titleSx}>
        {title}
      </Typography>
      {title2 && (
        <Typography variant="h2" className="text-blue-bb mt-2" sx={titleSx}>
          {title2}
        </Typography>
      )}
    </Box>
  )

  return (
    <Container
      disableGutters={titleLeft}
      className={`max-w-[100%] w-full bg-white-bb m-0 lg:pb-0 border-solid border-b  border-gray-cac ${
        defaultPadding ? 'p-[1]' : 'px-5 py-3'
      }`}
    >
      <Box
        className={cn(
          'flex flex-col lg:m-0 lg:w-full',
          { 'items-center': titleLeft, 'lg:items-center': !titleLeft },
          className
        )}
      >
        {titleLeft && (
          <Box
            className={cn('flex w-full', { 'max-w-[820px]': titleLeft })}
            sx={{ '@media (min-width:860px)': { marginLeft: '16px' } }}
          >
            {titleText}
          </Box>
        )}
        <Box
          className={cn(
            'flex flex-col sm:flex-row w-full pb-3',
            { 'px-5': !titleLeft },
            { 'lg:pt-3 sm:pt-1': !titleLeft },
            titleLeft
              ? 'max-w-[820px]'
              : centerSmallWidth
                ? 'lg:max-w-[350px]'
                : 'lg:max-w-[800px]',
            { 'lg:justify-between': !center },
            { 'lg:justify-center': center }
          )}
          sx={titleLeft ? { '@media (min-width:860px)': { marginLeft: '16px' } } : undefined}
        >
          <Box className="flex flex-col lg:items-start flex-1">
            {!titleLeft && titleText}
            {headLineText}
          </Box>
          {rightImage && (
            <Image
              className="mt-5 sm:mt-0 w-[128px] sm:w-[180px] lg:w-[230px] lg:h-[180px]"
              src={right_icon_image[rightImage]}
              alt="Casa"
            />
          )}
        </Box>
      </Box>
    </Container>
  )
}
